import fetch from 'cross-fetch';
import { encodeSearchParams } from './search-params';
export class TrelloClient {
    constructor({ baseUrl = '' } = {}) {
        this.baseUrl = baseUrl;
    }
    /**
     * @see https://developer.atlassian.com/cloud/trello/rest/#api-members-id-get
     */
    async getMember({ id = 'me', organizations, organizationFields, credits } = {}) {
        const searchParams = encodeSearchParams({
            organizations,
            organization_fields: organizationFields,
            credits
        });
        const response = await fetch(`${this.baseUrl}/1/members/${id}${searchParams ? `?${searchParams}` : ''}`, {
            credentials: 'include'
        });
        if (response.ok) {
            return await response.json();
        }
        else {
            throw Error(await response.text());
        }
    }
}
//# sourceMappingURL=trello-client.js.map